// extracted by mini-css-extract-plugin
module.exports = {"form":"snW6s0","submit":"xCHJYG","hidden":"TUR7hU"};